<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Puzzle-Walls-Generator-Root',
};
</script>
